import { wafflesKeyColumnName } from "@app/shared/waffles";
import InspectionProfileTableData from "./inspectionProfileTableData";
import { getSupplementalDataDecoration, valueOrDashes } from "./utils";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { AccuracyProviderDetail } from "@app/projects/results/accuracy/accuracyProviderDetail";
import { formatUnconvertedDateCustom } from "@app/shared/formatDateTime";

const unknownSourceName = "UNKNOWN";

// have to disable sort-keys here until we can change how the table data is generated on the panel.

/* oxlint-disable sort-keys */
export const generateSpecialtyProviderPanelRows = (rowKey: string, title: string, sourceRecord: AccuracyProviderDetail): InspectionProfileTableData => {
  return {
    [wafflesKeyColumnName]: rowKey,
    title: title,
    source: generateRowSource(sourceRecord),
    result: generateRowResults(sourceRecord),
    reference: generateRowReference(sourceRecord),
    attesterInfo: generateRowAttesterInfo(sourceRecord),
    attestationMethod: generateRowAttestationMethod(sourceRecord),
  };
}

const generateRowSource = (sourceRecord: AccuracyProviderDetail) => {
  return sourceRecord.specialty
    ? `${valueOrDashes(sourceRecord.specialtyCode)} - ${valueOrDashes(sourceRecord.specialty)}`
    : valueOrDashes(sourceRecord.specialtyCode);
}

const generateRowResults = (sourceRecord: AccuracyProviderDetail) => {
  const supplementSpecialtyCodes = sourceRecord.inspectionSupplement.specialtyCodes;
  const supplementalType = supplementSpecialtyCodes.supplementalType;
  return (
    (supplementSpecialtyCodes && supplementSpecialtyCodes.value.length > 0)
      ? (supplementSpecialtyCodes.value.map((specialty, index) => {
        return (
          <div key={index}>
            {getSupplementalDataDecoration(specialty, supplementalType, sourceRecord.specialtyCode)}
          </div>
        );
      }))
      : sourceRecord.inspectionSupplement.specialtyCodes
        ? (getSupplementalDataDecoration(null, supplementalType, sourceRecord.specialtyCode))
        : (
          <span className="text-muted">
            <QesIcon iconName={QesIcons.Help} description="The accuracy of this information is unknown" className="mx-2 align-text-top" />
          </span>
        )
  );
}

const generateRowReference = (sourceRecord: AccuracyProviderDetail) => {
  const supplementSpecialtyCodes = sourceRecord.inspectionSupplement.specialtyCodes;
  return (supplementSpecialtyCodes && supplementSpecialtyCodes.sourceName.toUpperCase() !== unknownSourceName)
          ?   <span>
                {valueOrDashes(supplementSpecialtyCodes.sourceName)}
                &nbsp;
                {supplementSpecialtyCodes.sourceName
                  ? valueOrDashes(supplementSpecialtyCodes.sourceDate ? `(${formatUnconvertedDateCustom(supplementSpecialtyCodes.sourceDate, "L")})` : "")
                  : null
                }
              </span>
          :   <span>{"---"}</span>
}

const generateRowAttesterInfo = (sourceRecord: AccuracyProviderDetail) => {
  return (sourceRecord.inspectionSupplement.specialtyCodes && sourceRecord.inspectionSupplement.specialtyCodes.attesterName?.toUpperCase() !== unknownSourceName) ?
    <span>
      {valueOrDashes(sourceRecord.inspectionSupplement.specialtyCodes.attesterName)}
      &nbsp;
      {(sourceRecord.inspectionSupplement.specialtyCodes.attesterName) ?
        valueOrDashes(sourceRecord.inspectionSupplement.specialtyCodes.attesterName ? `(${sourceRecord.inspectionSupplement.specialtyCodes.attesterRole})` : "") :
        null
      }
    </span> :
    <span>{"---"}</span>
}

const generateRowAttestationMethod = (sourceRecord: AccuracyProviderDetail) => {
  return <span>
    {valueOrDashes(sourceRecord.inspectionSupplement.specialtyCodes?.attestationMethod)}
  </span>
}